<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [resizable]="false"
  [draggable]="false"
  [closable]="false"
  [dismissableMask]="true"
  (onHide)="closeModal()"
  styleClass="activity-log-dialog"
  [style]="{ width: '90%', maxWidth: '440px', border: 'none', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)' }"
>
  <!-- Custom Dialog Content -->
  <div class="flex flex-col gap-6 pt-2 select-none">
    
    <!-- Header with Back Arrow and Title -->
    <div class="flex items-center justify-between pb-2 border-b border-gray-100">
      <button 
        type="button" 
        (click)="closeModal()" 
        class="w-9 h-9 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors border-0 bg-transparent cursor-pointer"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="w-5 h-5 text-gray-800">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
        </svg>
      </button>
      <h2 class="text-xl font-bold text-gray-900 m-0 text-center flex-1 pr-9">
        {{ activityToEdit ? 'Edit Activity' : 'Log Activity' }}
      </h2>
    </div>

    <!-- Section 1: Choose Activity Type -->
    <div class="flex flex-col gap-3">
      <label class="text-base font-semibold text-gray-800">Choose Activity Type</label>
      
      <!-- Categories Filter Bar -->
      <div class="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-none">
        <button
          *ngFor="let cat of categories"
          type="button"
          (click)="selectCategory(cat.id)"
          [class]="selectedCategoryId === cat.id ? 
            'px-4 py-1.5 rounded-full border border-[#22c55e] bg-[#f0fdf4] text-[#16a34a] font-bold text-xs transition-all whitespace-nowrap cursor-pointer' : 
            'px-4 py-1.5 rounded-full border border-gray-200 bg-white text-gray-600 font-semibold text-xs transition-all hover:bg-gray-50 whitespace-nowrap cursor-pointer'"
        >
          {{ cat.name }}
        </button>
      </div>

      <!-- Static Search Bar -->
      <div class="relative w-full">
        <span class="absolute inset-y-0 left-0 flex items-center pl-3.5 pointer-events-none">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-5 h-5 text-gray-400">
            <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.637 10.637z" />
          </svg>
        </span>
        <input
          type="text"
          [(ngModel)]="searchQuery"
          class="w-full bg-[#FAFAFA] border border-gray-100 rounded-2xl py-3 pl-11 pr-4 text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-[#22c55e] focus:bg-white transition-all duration-200"
          placeholder="Search activity..."
        />
      </div>

      <!-- Scrollable Activity List Container -->
      <div class="activity-list-container border border-gray-100 rounded-2xl overflow-hidden bg-white">
        <div class="max-h-64 overflow-y-auto divide-y divide-gray-50 pr-1">
          
          <div 
            *ngFor="let act of filteredActivityTypes" 
            (click)="selectActivity(act)"
            class="flex items-center justify-between p-3.5 cursor-pointer hover:bg-gray-50 transition-colors"
          >
            <!-- Left & Middle: Icon and Name -->
            <div class="flex items-center gap-3">
              <!-- Activity Icon Box (Rounded Full Avatar) -->
              <div class="w-12 h-12 rounded-full overflow-hidden flex items-center justify-center border border-gray-100 bg-gray-50 flex-shrink-0">
                <img 
                  *ngIf="act.image_url" 
                  [src]="act.image_url" 
                  [alt]="act.name"
                  class="w-full h-full object-cover"
                />
                <!-- Fallback Fitness SVG icon -->
                <svg 
                  *ngIf="!act.image_url" 
                  xmlns="http://www.w3.org/2000/svg" 
                  fill="none" 
                  viewBox="0 0 24 24" 
                  stroke-width="1.8" 
                  stroke="currentColor" 
                  class="w-5 h-5 text-gray-500"
                >
                  <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z" />
                </svg>
              </div>

              <!-- Name, Default Badge, and Category Label -->
              <div class="flex flex-col">
                <div class="flex items-center gap-2">
                  <span class="text-sm font-semibold text-gray-800">{{ act.name }}</span>
                  
                  <!-- Set Default Star Action Button -->
                  <button
                    *ngIf="!act.is_default"
                    type="button"
                    (click)="makeDefaultActivity(act, $event)"
                    class="w-7 h-7 flex items-center justify-center rounded-full hover:bg-amber-50 hover:text-amber-500 text-gray-300 border-0 bg-transparent cursor-pointer transition-all duration-200"
                    title="Set as Default Activity"
                  >
                    <i class="pi pi-star text-sm"></i>
                  </button>
                  <i
                    *ngIf="act.is_default"
                    class="pi pi-star-fill text-amber-500 text-sm ml-1"
                    title="Default Activity"
                  ></i>
                </div>
                
                <div class="flex items-center gap-1.5 mt-0.5 text-xs text-gray-500 font-semibold">
                  <span>{{ act.category_name }}</span>
                  <span *ngIf="act.is_default" class="text-gray-300">•</span>
                  <span 
                    *ngIf="act.is_default" 
                    class="bg-[#EAFDF5] text-[#10B981] px-2 py-0.5 rounded text-[10px] font-bold tracking-wide"
                  >
                    Default
                  </span>
                </div>
              </div>
            </div>

            <!-- Right: Custom Radio Button -->
            <div class="flex items-center pr-1">
              <!-- Checked State -->
              <div 
                *ngIf="selectedActivity?.id === act.id"
                class="w-5 h-5 rounded-full border-2 border-[#22c55e] flex items-center justify-center"
              >
                <div class="w-2.5 h-2.5 rounded-full bg-[#22c55e]"></div>
              </div>
              <!-- Unchecked State -->
              <div 
                *ngIf="selectedActivity?.id !== act.id"
                class="w-5 h-5 rounded-full border-2 border-gray-300"
              ></div>
            </div>
          </div>

          <!-- Empty Search State -->
          <div *ngIf="filteredActivityTypes.length === 0" class="p-6 text-center text-gray-400 text-sm">
            No activity types match your search.
          </div>

        </div>
      </div>
    </div>

    <!-- Section 2: How long did you exercise? -->
    <div class="flex flex-col gap-3">
      <label class="text-base font-semibold text-gray-800">How long did you exercise?</label>
      
      <!-- Quick Options and Custom Duration Selector -->
      <div class="flex items-center gap-2 overflow-x-auto pb-1 scrollbar-none">
        <button
          type="button"
          (click)="setDuration(10)"
          [class]="selectedDurationOption === 10 ?
            'px-4 py-2 rounded-full border border-[#22c55e] bg-[#f0fdf4] text-[#16a34a] font-bold text-xs flex items-center gap-1 cursor-pointer transition-all whitespace-nowrap' :
            'px-4 py-2 rounded-full border border-gray-200 bg-white text-gray-600 font-semibold text-xs flex items-center gap-1 cursor-pointer transition-all hover:bg-gray-50 whitespace-nowrap'"
        >
          <i class="pi pi-plus text-[9px]"></i> 10min
        </button>
        
        <button
          type="button"
          (click)="setDuration(20)"
          [class]="selectedDurationOption === 20 ?
            'px-4 py-2 rounded-full border border-[#22c55e] bg-[#f0fdf4] text-[#16a34a] font-bold text-xs flex items-center gap-1 cursor-pointer transition-all whitespace-nowrap' :
            'px-4 py-2 rounded-full border border-gray-200 bg-white text-gray-600 font-semibold text-xs flex items-center gap-1 cursor-pointer transition-all hover:bg-gray-50 whitespace-nowrap'"
        >
          <i class="pi pi-plus text-[9px]"></i> 20min
        </button>

        <button
          type="button"
          (click)="setDuration(30)"
          [class]="selectedDurationOption === 30 ?
            'px-4 py-2 rounded-full border border-[#22c55e] bg-[#f0fdf4] text-[#16a34a] font-bold text-xs flex items-center gap-1 cursor-pointer transition-all whitespace-nowrap' :
            'px-4 py-2 rounded-full border border-gray-200 bg-white text-gray-600 font-semibold text-xs flex items-center gap-1 cursor-pointer transition-all hover:bg-gray-50 whitespace-nowrap'"
        >
          <i class="pi pi-plus text-[9px]"></i> 30min
        </button>

        <button
          type="button"
          (click)="setCustomDuration()"
          [class]="selectedDurationOption === 'custom' ?
            'px-4 py-2 rounded-full border border-[#22c55e] bg-[#f0fdf4] text-[#16a34a] font-bold text-xs flex items-center gap-1.5 cursor-pointer transition-all whitespace-nowrap' :
            'px-4 py-2 rounded-full border border-gray-200 bg-white text-gray-600 font-semibold text-xs flex items-center gap-1.5 cursor-pointer transition-all hover:bg-gray-50 whitespace-nowrap'"
        >
          <i class="pi pi-pencil text-[9px]"></i> Custom
        </button>
      </div>

      <!-- Custom Duration Field -->
      <div *ngIf="selectedDurationOption === 'custom'" class="flex items-center gap-2 mt-1 bg-[#FAFAFA] border border-gray-100 rounded-2xl p-3">
        <span class="text-sm text-gray-500 font-semibold pl-1">Minutes:</span>
        <input
          type="number"
          [(ngModel)]="customMinutes"
          (keydown)="preventSymbols($event)"
          (paste)="preventPasteSymbols($event)"
          (input)="sanitizeInput()"
          min="1"
          max="1440"
          class="flex-1 bg-white border border-gray-200 rounded-xl px-3 py-2 text-sm text-gray-800 focus:outline-none focus:border-[#22c55e] transition-all font-semibold"
          placeholder="Duration in mins..."
        />
      </div>
    </div>

    <!-- Section 3: Action Button -->
    <div class="pt-2 flex flex-col gap-3">
      <!-- Validation warning -->
      <div *ngIf="validationErrorMessage" class="p-3 bg-red-50 border border-red-200 text-red-600 rounded-2xl flex items-start gap-2 text-xs font-semibold leading-relaxed">
        <i class="pi pi-exclamation-circle text-sm mt-0.5 flex-shrink-0"></i>
        <span>{{ validationErrorMessage }}</span>
      </div>

      <button
        (click)="logActivity()"
        [disabled]="!selectedActivity || !patientId || !!validationErrorMessage"
        class="w-full bg-[#22c55e] hover:bg-[#1ea34f] disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed text-white font-bold py-4 px-6 rounded-full flex items-center justify-center gap-2 transition-all duration-200 border-0 cursor-pointer text-base shadow-sm"
      >
        {{ activityToEdit ? 'Update Activity' : 'Log Activity +' }}
      </button>
    </div>

  </div>
</p-dialog>
